/*
 * @Author: gujianghua
 * @Date:   2018-07-21 18:00:58
 * @Last Modified by:   gujianghua
 * @Last Modified time: 2019-10-15 10:50:27
 */
import { service,BASE_API } from '@/utils/request'
import { searchParamsFormatter } from '@/api/common'
const v2 = BASE_API

export default {
  //获取直播源详情
  getLiveStatusApi: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/liveStatus',
      method: 'get',
      params: params
    })
  },
  //获取课件列表
  getCourseWare: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/courseWare/list',
      method: 'get',
      params: params
    })
  },
  //获取聊天历史
  getChatHistoryListApi: (params) => {
    return service({
      url: '/cloud/push/v1/imservice/chatMsglist',
      method: 'get',
      params: params
    })
  },
  //获取直播成员列表
  getMemberList: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/member/PageList',
      method: 'get',
      params: params
    })
  },
  //改变单个用户课堂状态
  changeMemberStatus: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/member/stateChange',
      method: 'post',
      params: params
    })
  },
  //添加/更新课件
  courseWareEdit(params, data) {
    return service({
      url: '/cloud/course/v1/admin/live/courseWare/addOrUpdate',
      method: 'post',
      params: params,
      data: data
    })
  },
  //im登录前获取签名
  getImUserSign() {
    return service({
      url: '/cloud/push/v1/user/getNewUserSign',
      method: 'get',
    })
  },
  //同步课件到客户端
  syncCourseWareToClient: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/courseWare/syncToClient',
      method: 'post',
      params: params
    })
  },
  //全体禁言/解除禁言
  allStateChangeApi: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/member/allStateChange',
      method: 'post',
      params: params
    })
  },
  //提问状态更改
  questionStateChangeApi: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/question/stateChange',
      method: 'post',
      params: params
    })
  },
  //结束课堂
  finishLive: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/finish',
      method: 'post',
      params: params
    })
  },
  //开始答疑
  startAnswerApi: (params) => {
    return service({
      url: '/cloud/course/v1/live/answerState/start',
      method: 'post',
      params: params
    })
  },
  //添加推送任务
  addTask: (data) => {
    return service({
      url: '/cloud/course/v1/admin/live/task/add',
      method: 'post',
      data: data
    })
  },
  //发送消息
  sendMsgFromServer: (data) => {
    return service({
      url: '/cloud/push/v1/imservice/sendMsgFromServer',
      method: 'post',
      data: data
    })
  },
  //获取提问列表
  getAllQestionList: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/question/pageList',
      method: 'get',
      params: params
    })
  },
  //提问列表统计
  getQuestionCount: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/question/overView',
      method: 'get',
      params: params
    })
  },
  //提问审核通过
  questionCheckApi: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/question/check',
      method: 'post',
      params: params
    })
  },
  //提问上墙
  questionPassReq: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/question/sync',
      method: 'post',
      params: params
    })
  },
  //提问跳过
  questionJump: (params) => {
    return service({
      url: '/cloud/course/v1/admin/live/question/skip',
      method: 'post',
      params: params
    })
  },
  //关闭发言
  closeSpeak: (params) => {
    return service({
      url: '/cloud/course/v1/live/rtc/changeState',
      method: 'post',
      params: params
    })
  },
  /**
  * [export 导出]
  * @param  {[obj]} data [筛选条件]
  * @return {[obj]}
  */
  exportExcel: function exportExcel(data) {
    console.log(data)
      let url = v2 + '/cloud/course/v1/admin/live/question/export?state=-2&' +
        searchParamsFormatter(data)
      window.location.href = url
  },

}



// WEBPACK FOOTER //
// ./src/api/contentManage/liveRoom.js